import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';

const vivaSuiteNavLoader = () => import(/* webpackChunkName: "4-feat-viva-suite-nav" */ './VivaSuiteNav');
export default lazyLoadOnRender({ loader: vivaSuiteNavLoader });
